// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button___2WEh2","ButtonRed":"Button__ButtonRed___8nOAr","ButtonWhite":"Button__ButtonWhite___2vUYW","ButtonBlack":"Button__ButtonBlack___27Cf1","ButtonBlackOutlined":"Button__ButtonBlackOutlined___l74zB","ButtonWhiteOutlined":"Button__ButtonWhiteOutlined___31Pqy","ButtonWhiteOutlinedWithOpacity":"Button__ButtonWhiteOutlinedWithOpacity___1ytcD","ButtonDisabled":"Button__ButtonDisabled___2KUju","ButtonFullWidth":"Button__ButtonFullWidth___SjHzW","LoadingSection":"Button__LoadingSection___WwjhU"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/Button/Button.less
// module id = 88
// module chunks = 0 1